'use strict';
{
    var app = angular.module('tf.portfolio.widgets.breakdownChart', [])

        .controller('breakdownChartCtrl', ['$scope', '$filter', '$localStorage', function breakdownChartController($scope, $filter, $localStorage) {
            $scope.widgetContentHeight = 500;

            $scope.icConcessionBySecurity = [];
            $scope.riskComparisons = [];
            $scope.premiumBySecurity = [];
            $scope.totalMarginBySecurity = [];
            $scope.scanRiskBySecurity = [];

            $scope.$on('gridster-resized', function() {
                $scope.updateChartHeight();
            });

            $scope.$watch('gridsterItem.sizeY', function() {
                $scope.updateChartHeight();
            });

            $scope.updateChartHeight = function() {
                $scope.widgetContentHeight = $scope.calculateAvailableWidgetHeight($scope.gridsterItem);
            };

            $scope.$on('margin.whatif.changed', function updateData(event, whatIfMargin) {
                var icConcessionBySecurity = [];
                var riskComparisons = [];
                var premiumBySecurity = [];

                var totalMarginBySecurity = [];
                var scanRiskBySecurity = [];

                for (var i = 0; i < whatIfMargin.combinedCommodities.length; i++) {
                    var cc = whatIfMargin.combinedCommodities[i];

                    if (cc.icConcession != 0) {
                        icConcessionBySecurity.push({value: cc.icConcession, label: cc.security});
                    }

                    if (cc.premiumMargin + cc.scanRisk > 0) {
                        totalMarginBySecurity.push({value: cc.premiumMargin + cc.scanRisk, label: cc.security});
                    }

                    if (cc.premiumMargin != 0) {
                        premiumBySecurity.push({value: cc.premiumMargin, label: cc.security});
                    }

                    if (cc.scanRisk != 0) {
                        scanRiskBySecurity.push({value: cc.scanRisk, label: cc.security});
                    }

                    riskComparisons.push({security : cc.security, data : [{value : cc.premiumMargin, label : cc.security + ' Prem'}, {value : cc.spanMargin, label : cc.security + ' Span'}]});
                }

                $scope.totalMarginBySecurity = totalMarginBySecurity;
                $scope.scanRiskBySecurity = scanRiskBySecurity;
                $scope.premiumBySecurity = premiumBySecurity;
                $scope.icConcessionBySecurity = icConcessionBySecurity;

                $scope.riskComparisons = riskComparisons;

            });

            $scope.securityBreakdownSummaryVisible = true;
            $scope.showSecurityBreakdownSummary = function() {
                $scope.securityBreakdownSummaryVisible = true;
            };

            $scope.showSecurityBreakdownDetail = function() {
                $scope.securityBreakdownSummaryVisible = false;
            };
        }])
        .directive('premiumBySecurity', function(){
            return {
                restrict: 'E',
                replace: true,
                template: '<div class="chart no-padding" style="height: 250px; width: 250px; margin: 0 auto;"></div>',
                scope : {
                    data : '='
                },
                link: function(scope, element){
                    var blues = ['#0B62A4', '#3980B5', '#679DC6', '#95BBD7', '#B0CCE1', '#095791', '#095085', '#083E67', '#052C48', '#042135'];
                    var reds = ['#ff9999','#ff7070', '#ff4747', '#ff1f1f', '#cc0000', '#b80000', '#990100', '#7a0000', '#660000', '#520000' ];
                    scope.total = 0;
                    scope.colours = [];
                    scope.chartData = [ {
                        value : 0,
                        label : 'bogus'
                    }];


                    var doughnut = Morris.Donut({
                        element: element,
                        colors: scope.colours,
                        data: scope.chartData,
                        formatter: function (x) {
                            return ((x / scope.total) * 100).toFixed(2) + "%";
                        }
                    });

                    scope.$watch('data', function(data) {

                        scope.total = 0;
                        var copy = data.slice();
                        copy.sort(function(a, b) {
                            if (a.value < b.value)
                                return 1;
                            if (a.value > b.value)
                                return -1;
                            return 0;
                        });

                        var redIndex = 0;
                        var blueIndex = 0;

                        scope.colours = [];
                        for (var i = 0; i < copy.length; i++) {
                            var d = copy[i];
                            scope.total += Math.abs(d.value);
                            if (d.value < 0) {
                                d.value = Math.abs(d.value);
                                scope.colours.push(reds[redIndex++]);
                                if (redIndex == reds.length) {
                                    redIndex = 0;
                                }
                            } else {
                                scope.colours.push(blues[blueIndex++])
                                if (blueIndex == blues.length) {
                                    blueIndex = 0;
                                }
                            }
                        }

                        scope.chartData = copy;

                        doughnut.options.colors = scope.colours;
                        doughnut.setData(scope.chartData);

                    });

                }
            }
        })
        .directive('morrisDonutGraph', function(){
            return {
                restrict: 'E',
                replace: true,
                template: '<div class="chart no-padding" style="height: 250px; width: 250px; margin: 0 auto;"></div>',
                scope : {
                    data : '='
                },
                link: function(scope, element){
                    scope.total = 0;
                    scope.chartData = [ {
                        value : 0,
                        label : 'bogus'
                    }];

                    var doughnut = Morris.Donut({
                        element: element,
                        data: scope.chartData,
                        formatter: function (x) {
                            return ((x / scope.total) * 100).toFixed(2) + "%";
                        }
                    });


                    scope.$watch('data', function(data) {
                        scope.total = 0;
                        var copy = data.slice();
                        copy.sort(function (a, b) {
                            if (a.value < b.value)
                                return 1;
                            if (a.value > b.value)
                                return -1;
                            return 0;
                        });

                        for (var i = 0; i < copy.length; i++) {
                            var d = copy[i];
                            scope.total += d.value;
                        }

                        scope.chartData = copy;
                        doughnut.setData(scope.chartData);

                    });
                }
            }
        })
        .directive('premiumAgainstScan', function(){
            return {
                restrict: 'E',
                replace: true,
                template: '<div class="chart no-padding" style="height: 250px; width: 250px; margin: 0 auto;"></div>',
                scope : {
                    data : '='
                },
                link: function(scope, element){
                    var blue = ['#0B62A4', '#3980B5'];
                    var red = ['#7E0100', '#7E0100'];

                    scope.total = 0;
                    scope.colours = [];
                    scope.chartData = [ {
                        value : 0,
                        label : 'bogus'
                    }];

                    var doughnut = Morris.Donut({
                        colors: scope.colours,
                        element: element,
                        data: scope.chartData,
                        formatter: function (x, data) {
                            return '$' + data.value.toFixed(0);
                        }
                    });

                    scope.$watch('data', function(data) {
                        scope.total = 0;

                        var copy = [];

                        for (var i = 0; i < data.length; i++) {
                            copy.push({value: data[i].value, label : data[i].label});
                        }

                        copy.sort(function (a, b) {
                            if (a.value < b.value)
                                return 1;
                            if (a.value > b.value)
                                return -1;
                            return 0;
                        });

                        scope.colours = [];

                        for (var i = 0; i < copy.length; i++) {
                            var d = copy[i];
                            d.origValue = d.value;
                            if (d.value < 0) {
                                scope.colours.push(red[i]);
                                d.value = Math.abs(d.value);
                            } else {
                                scope.colours.push(blue[i]);
                            }
                        }

                        scope.chartData = copy;

                        doughnut.options.colors = scope.colours;
                        doughnut.setData(scope.chartData);

                    });
                }
            }
        })
        ;
}